import Box from '@mui/material/Box';
import CRQIDHandler from 'pages/Flow/CRQIDHandler';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import NodeIDHandler from 'pages/Flow/NodeIDHandler';
import QuestionSidePanelDetails from 'pages/Flow/FlowSidePanel/QuestionSidePanelDetails';
import QuestionSidePanelPrivacy from 'pages/Flow/FlowSidePanel/QuestionSidePanelPrivacy';
import QuickreplyOutlinedIcon from '@mui/icons-material/QuickreplyOutlined';
import React from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { habuColors } from 'Theme';


const QuestionSidePanelLayout = ({ onClose, drawerInfo, isFlowEditMode }) => {
  const { data: node } = drawerInfo;
  const [tabValue, updateTab] = React.useState('question-details');
  const question = node?.data;
  const CRQID = node?.cleanRoomQuestionID || node?.data?.cleanRoomQuestion?.ID;

  if (!node.data) {
    return null;
  }

  return (
    <>
      <Toolbar sx={{ background: (theme) => theme.palette.secondary.light }}>
        <Grid container spacing={0} alignItems='center'>
          <Grid xs={11} item>
            <Box display='flex' alignItems='center'>
              <QuickreplyOutlinedIcon height={50} width={50} style={{ marginRight: '10px' }} />
              <Typography variant='h3' noWrap>
                Question Configuration
              </Typography>
            </Box>
          </Grid>
          <Grid xs={1} item>
            <IconButton aria-label='close' onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Toolbar>
      <Grid
        container
        spacing={0}
        sx={{ paddingX: 3, background: (theme) => theme.palette.secondary.light }}
      >
        <Grid xs={12} item>
          <NodeIDHandler nodeID={node.id} />
        </Grid>
        <Grid xs={12} item>
          <CRQIDHandler CRQID={CRQID} />
        </Grid>
        <Grid item xs={12}>
          <Typography variant='h4'>{question.title}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant='subtitle3' sx={{ color: habuColors.neutral[60] }}>
            {question.displayID}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={0} sx={{ background: (theme) => theme.palette.secondary.light }}>
        <Tabs
          indicatorColor='primary'
          onChange={(e, newValue) => updateTab(newValue)}
          value={tabValue}
          sx={{ paddingLeft: 3 }}
        >
          <Tab label='Details' value='question-details' data-testid='question-details-tab' />
          {isFlowEditMode ? (
            <Tab label='Settings' value='question-settings' data-testid='question-privacy-tab' />
          ) : null}
        </Tabs>
      </Grid>
      <Grid container spacing={0} sx={{ paddingX: 0 }}>
        {tabValue === 'question-details' && (
          <Grid item xs={12} sx={{ px: 3 }}>
            <QuestionSidePanelDetails question={question} node={node} />
          </Grid>
        )}
        {isFlowEditMode && tabValue === 'question-settings' && (
          <Grid item xs={12} sx={{ px: 3 }}>
            <QuestionSidePanelPrivacy node={node} question={question} />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default QuestionSidePanelLayout;
